import * as React from "react";
import { LinkProps, Link } from "react-router-dom";

declare type LinkButtonProps = LinkProps & { disabled?: boolean }
export const LinkButton = (props: LinkButtonProps) => {
    if (props.disabled) {
        const { disabled, style, to, replace, innerRef, children, ...rest } = props;
        return <a {...rest} style={{ ...style, color: "#8080809e" }}>{children}</a>
    } else {
        const { disabled, ...rest } = props;
        return <Link {...rest} />;
    }
}